import {gql, useLazyQuery} from '@apollo/client'
import {useFilterManagement} from '../../store/hooks/useFilterManagement'
import {usePersona} from '../../store/hooks/persona'

export default function useTotalUSPopulationQuery() {
  const TOTAL_US_POPULATION_QUERY = gql`
    query GetTotalUSPopulation($filters: Filters, $benefits: [BenefitEligibility]) {
      totalUsPopulation(filters: $filters, benefits: $benefits) {
        population
      }
    }
  `

  // Use unified filter management system
  const {getQueryParams, getOutreachParams} = useFilterManagement()
  const appliedFilterParams = getQueryParams()

  // Get outreach params (benefits only for now)
  const outreach = getOutreachParams()
  const benefitsData = outreach.type === 'benefits' ? outreach.data : []

  // Persona logic
  const {personas, personasToggle} = usePersona()
  const selectedPersonas = personasToggle ? {persona: personas} : {}

  const [conditionalTotalUSQuery, {data: totalPopulation, loading: loadingTotalPopulation}] = useLazyQuery(
    TOTAL_US_POPULATION_QUERY,
    {
      variables: {
        filters: {
          ...appliedFilterParams, // Applied filters: {gender: ["Male"], age: {min: 18, max: 65}}
          ...selectedPersonas // Persona filters
        },
        benefits: benefitsData // Outreach simulation benefits array
      },

      partialRefetch: false
    }
  )

  return [conditionalTotalUSQuery, {totalPopulation, loadingTotalPopulation}]
}
